import { render, staticRenderFns } from "./LabourRoom.vue?vue&type=template&id=13315888&scoped=true&"
import script from "./LabourRoom.vue?vue&type=script&lang=js&"
export * from "./LabourRoom.vue?vue&type=script&lang=js&"
import style0 from "./LabourRoom.vue?vue&type=style&index=0&id=13315888&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13315888",
  null
  
)

export default component.exports